module.exports = __webpack_public_path__ + "static/media/image.21e4eeec.png";